<template>
  <div class="air" @click="showRate = false">
    <el-dialog :title="rate.title" :visible.sync="showRatePop" width="16%" v-if="rate">
      <div v-for="(p,index) in rate.cont" class="flex-r flex-b lala blod" :key="index" >
        <span style="color:#413F69;opacity: 0.5;">{{p.name}}</span>
        <span>>=</span>
        <div>
          <span>{{p.value}}</span>
          <span style="color:#413F69;opacity: 0.5;">
            {{index===0?'μg/m³':'ppm'}}
          </span>
        </div>
      </div>
    </el-dialog>
    <comBox>
      <template v-slot:name><h4 style="font-size: 0.16rem;">新风控制</h4></template>
      <template v-slot:other>
        <el-dropdown>
          <h5>...</h5>
          <el-dropdown-menu slot="dropdown" v-show="areaDevs">
            <el-dropdown-item v-for="(dev,index) in areaDevs" :key="index" @click="airCode=dev.code">{{dev.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template v-slot:content>
        <div style="width:100%;height:4rem;margin-top:0.1rem;overflow-y:auto ;">
          <div class="top flex-r flex-c flex-center">
            <div class="circle" :class="{circle2: !choseSpeed && !openTime && !auto}">
              <div class="timeLong">00:15</div>
              <div class="other ellipsis"><span>{{auto?'自动':airOpen?'开启':'关闭'}}</span> {{auto?chosedRate?'|':'':airOpen?'|':''}} <span>{{auto?autoStates[chosedRate-1]:airOpen?speed+'档':''}}</span></div>
            </div>
            <div class="state flex flex-b" v-show="choseSpeed || openTime || auto">
               <!-- 选择风速 -->
                <div class="speedClass flex-r flex-rd" v-show="choseSpeed">
                  <div v-for="n in 3" :key="n" @click.stop="sendSpeed(n)" :class="{speedClassOver:speed===n}">
                      {{n}}档
                      <span v-show="speed===n">| {{speedText[n-1]}}</span>
                  </div>
                </div>
              <!-- 定时 -->
               <div class="timeClass flex-r flex-rd" v-show="openTime">
                  <div class="timeBlank flex-r flex-b">
                     <!-- 这里填时间-->
                       <div class="flex-r" style="height:100%;">
                        <span class="blod">开启</span>
                        <input type="text" v-model="startHour"/>
                        <span>:</span>
                        <input type="text" v-model="startMin"/>
                      </div>
                      <div class="flex-r"  style="height:100%;">
                       <span class="blod">关闭</span>
                       <input type="text" v-model="endHour"/>
                       <span>:</span>
                       <input type="text" v-model="endMin"/>
                      </div>
                  </div>
                  <div class="configTime" @click.stop="setTime()">
                    <i class="iconfont icon-Group-"></i>
                  </div>
               </div>
              <!-- 自动模式选择 -->
              <div class="autoClass flex-r flex-c" v-show="auto" style="position: relative;" :class="{autoClass2: showRate}">
                  <div class="flex-r flex-b" style="width: 100%;" @click.stop="showRate=!showRate">
                      <span style="color: #413F69;opacity: 0.5;margin-right: 0.25rem;">{{chosedRate?autoStates[chosedRate-1]:'请选择运行模式'}}</span>
                      <span style="color:#1890FF;margin-right: 0.25rem;" v-show="chosedRate" @click.stop="showPop(chosedRate-1)">查看标准</span>
                      <i class="el-icon-arrow-down"></i>
                  </div>
                  <transition name="fade">
                  <div class="flex-r flex-c autoState" style="width:100%;position: absolute;top:100%;left:0;z-index:99;background: #F6F8FB;border-radius: 0 0 0.2rem 0.2rem;" v-show="showRate">
                    <div v-for="(state,index) in autoStates" :key="index" class="flex-r autostate">
                      <span @click.stop="choseRate(index+1)" class="blod" style="margin-right: 0.3rem;">{{state}}</span>
                      <span style="color:#1890FF" @click.stop="showPop(index)">查看标准</span>
                   </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="tab flex-r flex-rd">
            <div class="flex-r flex-c" @click.stop="openA()">
               <div class="i-item" :class="{chosed:airOpen}"><i class="iconfont icon-iconfonticon2"></i></div>
               <span>关闭</span>
            </div>
            <div @click.stop="clickSpeed()">
               <div class="i-item" :class="{chosed:choseSpeed}"><i class="iconfont icon-fengsu"></i></div>
               <span>风速</span>
            </div>
            <div @click.stop="clickTime()">
              <div class="i-item" :class="{chosed:openTime}"><i class="iconfont icon-shijian1"></i></div>
               <span>定时</span>
            </div>
            <div @click.stop="clickAuto()">
              <div class="i-item" :class="{chosed:auto}"><i class="iconfont icon-zidong"></i></div>
               <span>自动</span>
            </div>
          </div>
        </div>
      </template>
    </comBox>
  </div>
</template>

<script>
import { stringTime, requestData } from '../../assets/js/commont.js'
import comBox from '../comBox/comBox'
export default {
  props: ['areaId'],
  components: {
    comBox
  },
  data () {
    return {
      model: 0, // 默认手动模式
      airOpen: false, // 新风开关总开关
      choseSpeed: false, // 选择风速
      openTime: false, // 定时
      auto: false, // 自动模式
      speed: 1, // 风速档位
      speedText: ['低速', '中速', '高速'],
      autoStates: ['中国优环境健康指数', 'WHO环境健康模式', '企业优环境健康模式'],
      showRate: false,
      chosedRate: '',
      startHour: '',
      endHour: '',
      startMin: '',
      endMin: '',
      airCode: '',
      showRatePop: false,
      rate: null,
      areaDevs: null,
      rates: [
        {
          title: '中国健康运行标准',
          cont: [
            {
              name: 'PM2.5',
              value: 15
            },
            {
              name: 'CO2',
              value: 800
            }
          ]
        },
        {
          title: 'WTO运行标准',
          cont: [
            {
              name: 'PM2.5',
              value: 35
            },
            {
              name: 'CO2',
              value: 1000
            }
          ]
        },
        {
          title: '室内空气质量 GBT18883',
          cont: [
            {
              name: 'PM2.5',
              value: 50
            },
            {
              name: 'CO2',
              value: 1000
            }
          ]
        }
      ]
    }
  },
  methods: {
    // 获取新风列表
    getFreshairList () {
      var data = {
        account: window.localStorage.getItem('account'),
        darea_id: this.areaId,
        is_all: 1,
        token: window.localStorage.getItem('token'),
        ts: stringTime(this.$myTime())
      }
      this.$http.post('https://www.airdaas.com/api/xf/getFreshairList', requestData(data)).then(res => {
        if (res.data.data.length) {
          this.areaDevs = res.data.data
          this.airCode = this.areaDevs[0].code
          this.$emit('hideAir', true)
        } else {
          this.$emit('hideAir', false)
        }
      })
    },
    // 第一步先开启总开关需要做的 发送请求或者关闭所有
    openA () {
      this.airOpen = !this.airOpen
      var data = {
        account: window.localStorage.getItem('account'),
        code: this.airCode,
        status: this.airOpen ? 1 : 0,
        token: window.localStorage.getItem('token'),
        ts: stringTime(this.$myTime())
      }
      this.$http.post('https://www.airdaas.com/api/xf/manualControl', requestData(data)).then(res => {
        if (res.data.data === 'success') {
          console.log('.')
        } else {
          this.airOpen = !this.airOpen
          this.$message({
            message: '操作失败',
            type: 'warning'
          })
        }
      })
    },
    // 点击新风风速操作
    clickSpeed () {
      if (this.airOpen) {
        this.choseSpeed = !this.choseSpeed
        if (this.choseSpeed) {
          this.openTime = false
          this.auto = false
        }
      } else {
        this.$message({
          message: '请先开启新风',
          type: 'warning'
        })
      }
    },
    // 点击选择时间操作
    clickTime () {
      if (this.airOpen) {
        this.openTime = !this.openTime
        if (this.openTime) {
          this.choseSpeed = false
          this.auto = false
        }
      } else {
        this.$message({
          message: '请先开启新风',
          type: 'warning'
        })
      }
    },
    clickAuto () {
      if (this.airOpen) {
        this.auto = !this.auto
        if (this.auto) {
          this.choseSpeed = false
          this.openTime = false
        }
      } else {
        this.$message({
          message: '请先开启新风',
          type: 'warning'
        })
      }
    },
    // 发送风速操作
    sendSpeed (n) {
      this.speed = n
      this.setTime()
    },
    // 显示标准-----------------------------------------
    showPop (index) {
      this.showRatePop = true
      this.rate = this.rates[index]
    },
    // 定时
    setTime () {
      if (this.startHour !== '' && this.endHour !== '' && this.startMin !== '' && this.endMin !== '') {
        if (this.startHour > this.endHour) {
          this.$message({
            message: '开始时间不能大于结束时间',
            type: 'warning'
          })
          return false
        } else if (this.startHour === this.endHour) {
          if (this.startMin > this.endMin) {
            this.$message({
              message: '开始时间不能大于结束时间',
              type: 'warning'
            })
            return false
          }
        }
        if (this.model === 1) {
          this.$message({
            message: '当前操作将切换为手动模式',
            type: 'warning'
          })
        }
        var data = {
          account: window.localStorage.getItem('account'),
          code: this.airCode,
          speed: this.speed,
          status: 1,
          timingmax: this.endHour + ':' + this.endMin,
          timingmin: this.startHour + ':' + this.startMin,
          token: window.localStorage.getItem('token'),
          ts: stringTime(this.$myTime())
        }
        this.$http.post('https://www.airdaas.com/api/xf/manualControl', requestData(data)).then(res => {
          if (res.data.data === 'success') {
            this.$message({
              message: '定时模式已开启',
              type: 'success'
            })
          }
        })
      } else {
        this.$message({
          message: '选择定时时间后才开启手动模式',
          type: 'warning'
        })
      }
    },
    // 自动挡控制
    autoModel () {
      var data = {
        account: window.localStorage.getItem('account'),
        code: this.airCode,
        model: this.chosedRate,
        token: window.localStorage.getItem('token'),
        ts: stringTime(this.$myTime())
      }
      this.$http.post('https://www.airdaas.com/api/xf/autoControl', requestData(data)).then(res => {
        if (res.data.data === 'success') {
          this.model = 1
          this.$message({
            message: '开启自动模式',
            type: 'success'
          })
        }
      })
    },
    // 通过soket获取新风状态
    soket () {
      var t = (window.location.protocol === 'http:' ? 'ws://139.224.119.100:1140' : 'wss://www.iaqcloud.com/wss')
      var ws = new WebSocket(t)
      var self = this
      ws.onopen = function () {
        var json = { action: 'getxfinfo', code: self.airCode }
        json = JSON.stringify(json)
        ws.send(json)
      }
      ws.onmessage = function (e) {
        // console.log(JSON.parse(e.data))
        var data = JSON.parse(e.data)
        self.model = parseInt(data.model)
        // 修改本地状态
        if (parseInt(data.model) === 0) {
          self.speed = parseInt(data.fl)
          self.startHour = data.dkh
          self.startMin = data.dkm
          self.endHour = data.dgh
          self.endMin = data.dgm
          self.auto = false
          // console.log(parseInt(data.status))
          if (parseInt(data.status) === 1) {
            self.airOpen = true
          } else {
            self.airOpen = false
          }
        } else {
          self.auto = true
          self.openTime = false
          self.choseSpeed = false
          if (parseInt(data.status) === 1) {
            self.airOpen = true
          } else {
            self.airOpen = false
          }
          self.chosedRate = data.zdmodel
        }
        setTimeout(() => {
          ws.send(1)
        }, 30000)
      }
    },
    // 选择新风模式
    choseRate (index) {
      this.chosedRate = index
      this.autoModel()
    }
  },
  watch: {
    // 监听区域id获取新风设备
    areaId () {
      this.$nextTick(() => {
        this.getFreshairList()
      })
    },
    // 监听新风设备 获取新风状态
    airCode () {
      this.$nextTick(() => {
        this.soket()
      })
    },
    airOpen (value) {
      if (!value) {
        this.openTime = false
        this.choseSpeed = false
        this.auto = false
      }
    },
    // 时间处理
    startHour (value) {
      if (parseInt(value) > 24) {
        this.startHour = 0
      } else if (parseInt(value) < 0) {
        this.startHour = 24
      }
    },
    // 时间处理
    endHour (value) {
      if (parseInt(value) > 24) {
        this.endHour = 0
      } else if (parseInt(value) < 0) {
        this.endHour = 24
      }
    },
    startMin (value) {
      if (parseInt(value) > 60) {
        this.startMin = 0
      } else if (parseInt(value) < 0) {
        this.startMin = 60
      }
    },
    // 时间处理
    endMin (value) {
      if (parseInt(value) > 60) {
        this.endMin = 0
      } else if (parseInt(value) < 0) {
        this.endMin = 60
      }
    }
  }
}
</script>

<style lang="less" scoped>
.air{
  font-size: 0.14rem;
  .el-dialog__title{
    font-size: 0.14rem;
  }
  div {
    cursor: pointer;
  }
  width:100%;
  height:100%;
  .top{
    height:2.8rem;
    width:100%;
    margin:0.2rem 0;
    .circle{
      width:2rem;
      height:2rem;
      border-radius:50%;
      justify-content:center;
      background:#1890FF;
      color:white;
      display:flex;
      flex-direction:column;
      .timeLong{
        width:100%;
        font-size: 0.4rem;
        margin-bottom:0.12rem;
      }
      .other{
        width:0.8rem;
        margin:0 auto;
        text-align: center;
      }
    }
    @keyframes move {
     from {width: 2rem;height:2rem;transform: scale(1) translate(0,0);box-shadow: none;}
     to {width: 2.2rem;height:2.2rem;transform:  translateY(0.1rem);box-shadow: 0 0 0px 10px rgba(24,144,255,0.4);}
     }
     @-webkit-keyframes move {
       from {width: 2rem;height:2rem;transform: scale(1) translate(0,0);box-shadow: none;}
       to {width: 2.2rem;height:2.2rem;transform:  translateY(0.1rem);box-shadow: 0 0 0px 10px rgba(24,144,255,0.4);}
    }
    .circle2{
      animation: move 0.3s;
      -webkit-animation: move 0.3s;
      width:2.2rem;
      height:2.2rem;
      transform:  translateY(0.1rem);
      box-shadow: 0 0 0px 10px rgba(24,144,255,0.4);
    }
    .state{
      width:100%;
      margin-top:0.24rem;
      height:0.4rem;
      .speedClass{
        width:100%;
        height:100%;
        div{
          height:100%;
          border-radius: 0.2rem;
          padding:0.1rem 0.24rem;
          font-size:0.14rem;
          color: #8F8EA7;
          border:1px solid rgba(0,0,0,0.1);
          line-height:0.2rem;
        }
        .speedClassOver{
          background:#1890FF;
          color:white;
          border:none;
         }
      }
      .timeClass{
        height:100%;
        .timeBlank{
          flex:1;
          padding:0.1rem 0.24rem;
          height:100%;
          background:rgba(209, 218, 236, 0.2);
          border-radius:0.2rem;
          div {
            span:nth-child(3){
              color:#ccc;
            }
            input {
              width:0.3rem;
              border:none;
              background:none;
              margin:0 0.05rem;
              border-bottom:1px solid #ccc;
              text-align:center;
            }
          }
        }
        .configTime{
        width:0.4rem;
        height:0.4rem;
        background:#1890FF;
        margin-left:0.24rem;
        border-radius:50%;
        font-size:0.24rem;
        color:#fff;
        line-height: 0.4rem;
        text-align: center;
      }
      }
      .autoClass{
        width:88%;
        margin:0 auto;
        padding: 0.1rem 0.24rem;
        background: #F6F8FB;
        line-height: 0.2rem;
        border-radius: 0.2rem;
      }
      .autoClass2{
        border-radius: 0.2rem 0.2rem 0 0;
      }
    }
  }
}
.tab{
  font-size: 0.16rem;
  width:100%;
  color:#201D4E;
  font-weight:400;
  .iconfont{
    font-weight:400;
  }
  .i-item{
    width:0.4rem;
    height:0.4rem;
    text-align:center;
    line-height:0.4rem;
    border-radius:50%;
    border:1px solid rgba(0,0,0,0.1);
    margin-bottom:0.2rem;
  }
  .chosed{
  background: #1890FF;
    border:none;
  .iconfont{
    color:white;
  }
}
}
.autostate{
  width:100%;
  padding:0.1rem 0.24rem;
  line-height: 0.2rem;
}
.lala{
  font-size: 0.14rem;
  height:0.48rem;
}
</style>
